import React from "react";
import { Loader2 } from "lucide-react";
import * as TooltipPrimitives from "@radix-ui/react-tooltip";
import { Button } from "components/Graphs/Button";

export const LaunchableActionBar: React.FC<{
  canCreate: boolean;
  isEditMode: boolean;
  loadingCreatingLaunchable: boolean;
  onSave: () => void;
  onCancel: () => void;
}> = ({
  canCreate,
  isEditMode,
  loadingCreatingLaunchable,
  onSave,
  onCancel,
}) => {
  const actionLabel = isEditMode ? "Save" : "Create Launchable";
  const requiredFieldsTooltip =
    !canCreate && !loadingCreatingLaunchable
      ? "Complete the required fields highlighted above."
      : "";

  const actionButton = (
    <Button
      type="button"
      className="h-9 gap-2 disabled:text-zinc-600 dark:disabled:text-zinc-300"
      disabled={!!(!canCreate || loadingCreatingLaunchable)}
      onClick={onSave}
    >
      {loadingCreatingLaunchable && (
        <Loader2 className="h-4 w-4 animate-spin" />
      )}
      {actionLabel}
    </Button>
  );

  return (
    <div className="flex flex-wrap gap-2">
      {requiredFieldsTooltip ? (
        <TooltipPrimitives.Provider>
          <TooltipPrimitives.Root delayDuration={0}>
            <TooltipPrimitives.Trigger asChild>
              <span
                className="inline-flex"
                tabIndex={0}
                aria-label={requiredFieldsTooltip}
              >
                {actionButton}
              </span>
            </TooltipPrimitives.Trigger>
            <TooltipPrimitives.Portal>
              <TooltipPrimitives.Content
                side="top"
                sideOffset={4}
                className="z-50 max-w-xs rounded-md bg-zinc-800 px-3 py-2 text-xs text-white shadow-md"
              >
                {requiredFieldsTooltip}
                <TooltipPrimitives.Arrow className="fill-zinc-800" />
              </TooltipPrimitives.Content>
            </TooltipPrimitives.Portal>
          </TooltipPrimitives.Root>
        </TooltipPrimitives.Provider>
      ) : (
        actionButton
      )}
      <Button
        type="button"
        variant="secondary"
        className="h-9"
        disabled={loadingCreatingLaunchable}
        onClick={onCancel}
      >
        Cancel
      </Button>
    </div>
  );
};
